import { render, staticRenderFns } from "./MainTopNavbar.vue?vue&type=template&id=398cf0a5&scoped=true&"
import script from "./MainTopNavbar.vue?vue&type=script&lang=js&"
export * from "./MainTopNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainTopNavbar.vue?vue&type=style&index=0&id=398cf0a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398cf0a5",
  null
  
)

export default component.exports